<script setup lang="ts">
import { useNuxtApp } from "#app";
import SvgIcon from "../SvgIcon.vue";
import { useAuthStore } from "~/store/auth/auth.store";
import { useUsersStore } from "~/store/users/users.store";
import { useFeedback } from "~/composables/feedback/useFeedback";

const { $Localize } = useNuxtApp();
const authStore = useAuthStore();
const usersStore = useUsersStore();

const toggled = ref(false);
const selectedVal = ref("");
const dropdown = ref<HTMLInputElement | null>(null);
const options = ["FR", "EN", "DE"];

const optionsAvailable = computed(() => {
  return options?.filter((opt) => {
    return selectedVal.value !== opt;
  });
});

function untoggleDropdown(event: any) {
  if (dropdown.value && !dropdown.value.contains(event.target)) {
    toggled.value = false;
  }
}

onMounted(() => {
  selectedVal.value = (authStore.user?.language ?? "FR").toUpperCase();
  document.addEventListener("click", untoggleDropdown);
});

onUnmounted(() => {
  document.removeEventListener("click", untoggleDropdown);
});

async function selectOpt(opt: any) {
  const feedback = useFeedback();
  selectedVal.value = opt;
  toggled.value = false;

  // Dirty fix to type Localize variable
  const typedLocalize: any = $Localize;
  typedLocalize.setLanguage(opt.toLowerCase());
  if (authStore.isLoggedIn()) {
    try {
      await usersStore.setUserLanguage(opt.toLowerCase());
      if (authStore.user) {
        authStore.user.language = opt.toLowerCase();
      }
    } catch {
      feedback.error(`Une erreur est survenue`, "small");
    }
  }
  /**
   * we do not set i18n local to EN because Localize do the trad
   */
  // locale.value = opt.toLowerCase()
}
</script>

<template>
  <div ref="dropdown" class="small_dropdown__container small_regular">
    <div class="small_dropdown__toggle sub" :data-toggled="toggled" @click="toggled = !toggled">
      <p class="small_dropdown__selected">{{ selectedVal }}</p>
      <SvgIcon name="arrow_down" class="min-h-[22px] min-w-[22px] max-h-[22px] max-w-[22px] mr-[2px]" />
    </div>
    <div class="dropdown__menu sub" :class="[toggled ? 'block' : 'hidden']">
      <ul v-for="opt in optionsAvailable" :key="opt" @click="selectOpt(opt)">
        <li class="small_dropdown__option small_dropdown__padding">
          {{ opt }}
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped lang="scss">
.small_dropdown__container {
  position: relative;
  cursor: default;

  --tmp: var(--grey-lightest);

  &[data-disabled="false"] {
    cursor: pointer;

    &:hover {
      --tmp: var(--primary-blue-color);
    }

    .sub {
      border-color: var(--tmp);

      &:has(.dropdown__input:focus) {
        --tmp: var(--primary-blue-color);

        + .sub {
          --tmp: var(--primary-blue-color);
        }
      }
    }
  }

  &[data-disabled="true"] {
    .sub {
      border-color: transparent;
      color: var(--text-tertiary-color);
    }
  }
}

.small_dropdown__toggle {
  display: flex;
  align-items: center;
  background: var(--grey-light);
  border: 1px solid var(--grey-lightest);
  border-radius: var(--border-radius);
  color: var(--text-main-color);
  white-space: normal;
  width: 100%;

  &[data-toggled="true"] {
    border-radius: var(--border-radius) var(--border-radius) 0 0;
    box-shadow: var(--shadow-soft);
  }
}

.small_dropdown__selected {
  display: flex;
  flex-grow: 1;
  flex-basis: 100%;
  white-space: nowrap;
  padding: 3px 0 3px 10px;
  overflow-x: hidden;
  width: 100%;

  &[data-searchable="true"] {
    padding-right: 16px;
  }
}

.small_dropdown__padding {
  padding: 3px 10px;
}

.small_dropdown__option {
  display: block;
  clear: both;
  color: var(--text-main-color);
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  overflow-x: hidden;

  &:hover {
    background: var(--grey-lightest);
  }
}
</style>
